import type { DomainAccountingObject } from "@exopengithub/planning-api-shared";
import { createEntityAdapter } from "@reduxjs/toolkit";

export const accountingObjectsAdapter =
	createEntityAdapter<DomainAccountingObject>();

export const accountingObjectsSelectors =
	accountingObjectsAdapter.getSelectors();
